export default {
  SUCCESS: 'SUCCESS',
  UPDATING: 'UPDATING',
  ERROR: 'ERROR',
  NETWORK_ERROR: Symbol('NETWORK_ERROR'),
  NOT_STARTED: 'NOT_STARTED',
  STARTED: 'STARTED',
  LOADING: 'LOADING',
  PLACING_ORDER: 'PLACING_ORDER',
  VERIFICATION_SUCCESS: 'VERIFICATION_SUCCESS',
};
